<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('assets-list')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('Assets')}}
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('assets-list')}}
            </li>
        </ol>
    </div>
    @if (isLoadingResults || isRateLimitReached) {
    <div class="loading-shade">
        @if (isLoadingResults) {
        <mat-spinner></mat-spinner>
        }
        @if (isRateLimitReached) {
        <div class="rate-limit-reached">
            ALTAIR rate limit has been reached. It will be reset in one minute.
        </div>
        }
    </div>
    }
    <!-- Assets -->
    <mat-card class="altair-card companies-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-header>
            <mat-card-title>
                <form class="search-box position-relative">
                    <i class="material-symbols-outlined">
                        search
                    </i>
                    <input matInput class="input-search d-block w-100 border-none outline-0"
                        placeholder="{{t('search')}} {{t('asset')}}..." (keyup)="applyFilter($event)"
                        (keydown.enter)="onKeydown($event)" #input>
                </form>
            </mat-card-title>
            <mat-card-subtitle>
                <a mat-button class="add-new-btn" routerLink="/masters/create-asset">
                    + {{t('add-new-asset')}}
                </a>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <div class="companies-table">
                <div class="table-responsive">
                    <table mat-table [dataSource]="dataSource" matSort matSortActive="created" matSortDisableClear
                        matSortDirection="asc">

                        <!-- Name Column -->
                        <ng-container matColumnDef="created">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('created')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{(row.created  ? row.created.substring(0, 19).replace("T", " ") : '')}}
                            </td>
                        </ng-container>

                        <!-- Name Column -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('name')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.name}}
                            </td>
                        </ng-container>

                        <!-- Domain Column -->
                        <ng-container matColumnDef="domain">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('domain')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.brand.domain}}
                            </td>
                        </ng-container>

                        <!-- Status Column -->
                        <ng-container matColumnDef="assetVerificationStatus">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                {{t('status')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                {{row.assetVerificationStatus.name}}
                            </td>
                        </ng-container>

                        <!-- Action Column -->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>
                                {{t('action')}}
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <div class="action-info">
                                    <a mat-button routerLink="/masters/edit-asset/{{row.id}}"
                                        matTooltip="{{t('edit')}} {{t('asset')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            edit
                                        </i>
                                    </a>
                                    <button type="button" mat-button (click)="delete(row.id)"
                                        matTooltip="{{t('delete')}} {{t('asset')}}" matTooltipPosition="above">
                                        <i class="material-symbols-outlined">
                                            delete
                                        </i>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">{{t('no-data-matching')}} "{{input.value}}"</td>
                        </tr>

                    </table>
                </div>
                <mat-paginator [length]="totalItems" [pageSizeOptions]="pageSizes" showFirstLastButtons></mat-paginator>
            </div>
        </mat-card-content>
    </mat-card>
</ng-container>
